import { useSuspenseQuery } from '@tanstack/react-query'

import { useAuthorization } from '../../authentication'
import { lessonEntityQueries } from './lesson.query'

export const useGetTutorLessonsBySelectedTopic = () => {
  const { bearerToken } = useAuthorization()

  return useSuspenseQuery({
    ...lessonEntityQueries.getTutorLessonsBySelectedTopic({ bearerToken }),
  })
}
